export default class {

    // @ngInject
    constructor(responseHandler, authService) {
        this.responseHandler = responseHandler;
        this.authService = authService;
        this.data = {
            old_password: undefined,
            new_password1: undefined,
            new_password2: undefined
        };
    }

    submit() {
        let promise = this.authService.changePassword(this.data);
        return this.responseHandler(promise, 'changing your password').then(() => {
            if (this.form.setFormSuccess) {
                this.form.setFormSuccess('Your password has been changed.');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./user/change-password/change-password.js